import {createGrid} from "../../helpers/grids/grids";
import {createCellRenderer, createTruncatedTextCellRenderer} from "../../helpers/grids/helpers";
import createElement from "../../helpers/createElement";

function initManageVoeOrders() {
	createGrid(
		'.client-voe-orders-grid',
		{
			columnDefs: [
				{
					field: "public_id",
					headerName: 'Order Id',
					tooltipField: 'public_id',
					cellRenderer: createTruncatedTextCellRenderer(10, true),
				},
				{
					field: "full_name",
					headerName: 'Full Name',
					sortable: true,
				},
				{
					field: "company_name",
					headerName: 'Company Name',
					sortable: true,
				},
				{
					field: "status_label",
					headerName: 'Status',
				},
				{
					field: "timeInQueue",
					headerName: 'Total Time',
					sortable: true,
				},
				{
					field: "public_id",
					headerName: '',
					sortable: false,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						return createElement(`
							<div class="buttons">
								<a
									class="btn btn-primary btn-sm" href="${params.data.manage_url}"
								>
									<i class="fa-solid fa-bars-progress"></i>
									Manage
								</a>
							</div>
						`);
					})
				}
			],
			rowClass: 'cursor-pointer',
			paginationPageSize: 20,
			_rowName: 'Orders',
			_autoRefresh: true,
		},
		window['routes/client.grid']
	);

	/**
	 * Methods
	 */

}

export {initManageVoeOrders}
